const timestamps = new Map<string, number[]>();

/**
 * Returns true if the request is allowed, false if the rate limit is exceeded.
 * @param key       Unique key per action (e.g. 'contact-form', 'chat-message')
 * @param max       Max requests allowed within the window
 * @param windowMs  Time window in milliseconds
 */
export function checkRateLimit(
    key: string,
    max: number = 5,
    windowMs: number = 60_000
): boolean {
    const now = Date.now();
    const recent = (timestamps.get(key) ?? []).filter((t) => now - t < windowMs);

    if (recent.length >= max) return false;

    recent.push(now);
    timestamps.set(key, recent);
    return true;
}

export function getRateLimitRemaining(
    key: string,
    max: number = 5,
    windowMs: number = 60_000
): number {
    const now = Date.now();
    const recent = (timestamps.get(key) ?? []).filter((t) => now - t < windowMs);
    return Math.max(0, max - recent.length);
}
